import { JSX, useMemo, useState } from 'react'
import { State } from 'src/components/registerBusinessLegacy/standardRegister'
import Account from 'src/components/registerBusinessLegacy/standardRegister/AccountStep'
import Confirmation from 'src/components/registerBusinessLegacy/standardRegister/ConfirmationStep'
import EmailStep from 'src/components/registerBusinessLegacy/standardRegister/EmailStep'
import Form from './Form'

export type StandardRegisterProps = {
  firstName: string
  lastName: string
  email: string
  password: string
  isAuthenticated: boolean
  preRegistrationToken: string | null
  returnUrl: string | null
  cartId: number | null
  acceptAccountTerms: boolean
  offersByEmail: boolean
}

const StandardRegister = (props: StandardRegisterProps) => {
  const [state, setState] = useState<State>(!props.isAuthenticated ? State.email : State.account)

  const handleStateChange = (state: State) => {
    setState(state)
  }

  const content: JSX.Element = useMemo(() => {
    switch (state) {
      case State.email:
        return <EmailStep onNavigateNext={() => handleStateChange(State.account)} />
      case State.account:
        return <Account isConsumer onNavigateBack={() => handleStateChange(State.email)} />
      case State.confirmation:
        return <Confirmation />
      default:
        return <></>
    }
  }, [state])

  return (
    <Form onStateChange={handleStateChange} state={state} defaultValues={props} {...props}>
      {content}
    </Form>
  )
}

export default StandardRegister
